import Script from 'next/script'

const YieldbirdOld = () => (
  <Script
    id="yieldbird-script"
    data-testid="yieldbird-script"
    src="//jscdn.yieldbird.com/d67edacf-d1f9-4edd-a8ea-a94a7f86c921/yb.js"
    strategy="lazyOnload"
  />
)

export default YieldbirdOld
